import React from "react";
import Testimonials from "../components/testimonial/Testimonials";
import { Box, Typography } from "@mui/material";
import BreadcrumbsTemplate from "../components/misc/BreadcrumbsTemplate";
import { colors, eyebrowSx, fonts } from "../theme/designTokens";

export default function TestimonialScreen() {
  return (
    <Box sx={{ bgcolor: colors.paper }}>
      <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 } }}>
        <Box sx={{ pt: 2.5 }}>
          <BreadcrumbsTemplate b3="Testimonial" sx={{ mx: 0 }} />
        </Box>

        <Box sx={{ textAlign: "center", maxWidth: 640, mx: "auto", pt: 3, pb: 5 }}>
          <Box sx={eyebrowSx}>Customer Stories</Box>
          <Typography
            sx={{
              fontFamily: fonts.display,
              fontWeight: 800,
              fontSize: { xs: "1.8rem", sm: "2.2rem" },
              color: colors.ink,
              mt: 2,
            }}
          >
            Our Valued Customers
          </Typography>
        </Box>

        <Box sx={{ pb: 6 }}>
          <Testimonials columns={3} />
        </Box>
      </Box>
    </Box>
  );
}
